import { makeAutoObservable, observable } from "mobx";
import Storage from "utils/storage";
import StoreCurrency from "store/currency";
import { get_symbol, get_plate, get_symbolFeeRate, get_leverSymbol, get_broker_link } from "api/v4/market";
// import { get_marketConfig } from "api/old/xt-lever";
import { get_marketTips } from "api/old/xt-app";
import { post_getEtfByTradeMarket } from "api/old/xt-redemption";
import { get_fapiSymbolList } from "api/old/futures";
import { get_fapiAccountOpen, get_dapiAccountOpen, get_fapiCoins, get_dapiCoins, get_equityCoins, get_equityTransLimit } from "api/v4/futures";
import { get_exchange_list } from "@/api/v4/exchange";

export interface SymbolFilterProps {
  filter: "PRICE" | "QUANTITY";
  max: string;
  min: string;
  tickSize: string;
}

export interface SymbolProps extends ObjAny {
  symbol: string; //市场名称
  quantityPrecision: number; //卖方币市场精度
  pricePrecision: number; //买方币市场精度
  plates: number[]; //板块列表id
  state: string; //交易对状态[ONLINE=上线的;OFFLINE=下线的,DELISTED=退市]
  nextState: null | string; //下一个状态
  nextStateTime: null | number; //下一个状态时间
  displayLevel: string; //展示级别,[FULL=完全展示,SEARCH=搜索展示,DIRECT=直达展示,NONE=不展示]
  tradingEnabled: boolean; //是否启动交易(暂停交易)
  displayWeight: number; //展示权重，越大越靠前
  depthMergePrecision: number; //深度合并精度
  type: string; //类型 nft | normal
  filters?: SymbolFilterProps[]; //过滤器
}

export interface LeverSymbolProps extends ObjAny {
  // marketName: string; //市场名称
  symbol: string; //市场名称
  maxLeverage: number; //最大杠杆倍数
  maxLoanAmountBuy: string; //买方币种最大可借
  maxLoanAmountSell: string; //卖方币种最大可借
  liquidationRate: string; //爆仓风险率，市场风险率
  tipsRate: string; //提醒系数，预警风险率
  dailyInterestRate: string; //日利率
}

export interface FuturesSymbolProps extends ObjAny {
  symbol: string; //交易对名称
}

export interface EtfConfigDataProps {
  id: number;
  multiple: number;
  dealPair: string;
}

interface EtfConfigProps {
  data: EtfConfigDataProps[];
}

interface TipsProps extends ObjAny {
  tipsType: number;
  content: string;
  link?: string;
}

interface PlateProps {
  id: string;
  plate: string;
}

export enum TypeEnum {
  spot = "EQUITY", //股票
  lever = "LEVER", //杠杆
}

export interface IEtfDealPairItemProps {
  coinVol: number;
  dealPairName: string;
  name: string;
  high: number;
  low: number;
  moneyVol: number;
  multiple: number;
  price: number;
  rate: number;
}

interface FeeRateProps {
  takerFeeRate: number;
  makerFeeRate: number;
}
interface exChangeCoinProps {
  convert: any;
  currencies: string[];
  slippage: number;
}
export interface EtfProps {
  symbol: string;
  maxLeverage: number;
  baseCurrency: string;
  direction: string;
  instruction: string;
  managementRate: string;
  initialNetWorth: string;
  latestNetWorth: string;
  logo: string;
}

export interface equityLimitProps {
  whiteEnabled: boolean;
  isWhite: number;
  transferEnabled: boolean;
  minAmount: number;
  currencyAmountMap: any;
}

interface StateProps {
  name: string;
  type: TypeEnum;
  tips: ObjT<TipsProps>;
  symbols: WithUndefined<SymbolProps[]>;
  leverConfigAry: WithUndefined<LeverSymbolProps[]>;
  etfConfig: WithUndefined<ObjT<EtfConfigProps>>;
  plateList: PlateProps[];
  netWorth: string;
  etfDealPairListData: IEtfDealPairItemProps[];
  isFuturesUsdtOpen: WithUndefined<boolean>;
  isFuturesCoinOpen: WithUndefined<boolean>;
  isEquityTransferOpen: WithUndefined<boolean>;
  isEquityWhiteOpen: WithUndefined<boolean>;
  isEquityWithdraw: WithUndefined<boolean>;
  futuresUsdtTransferList: WithUndefined<string[]>;
  futuresCoinTransferList: WithUndefined<string[]>;
  equityCoinTransferList: WithUndefined<string[]>;
  equityExChangeList: WithUndefined<exChangeCoinProps>;
  futuresUsdtConfigAry: WithUndefined<FuturesSymbolProps[]>;
  feeRate: ObjT<FeeRateProps>;
  etfList?: EtfProps[]; //etf交易对列表
  etfListBase?: EtfProps[]; //etf单个配置
  equityLimit: WithUndefined<equityLimitProps>;
  isEquityHK: WithUndefined<boolean>;
  brokerLink: WithUndefined<string>;
}

let loading_getMarketConfig = false;
let TimeoutFun_loopGetMarketConfig, CancelFun_loopGetMarketConfig;

const market = makeAutoObservable(
  {
    name: "" as StateProps["name"], //当前市场名称
    type: TypeEnum.spot as StateProps["type"], //当前市场类型，spot=现货，lever=杠杆
    tips: {} as ObjT<TipsProps>, //所有市场风险提示信息
    symbols: undefined as StateProps["symbols"], //所有市场配置信息，数组
    leverConfigAry: undefined as StateProps["leverConfigAry"], //杠杆所有市场配置信息，数组
    etfConfig: undefined as StateProps["etfConfig"], //现货市场对应的etf市场对象
    plateList: [] as StateProps["plateList"], //板块列表
    netWorth: "" as StateProps["netWorth"], //etf当前市场，通证净值
    etfDealPairListData: [] as StateProps["etfDealPairListData"], //etf交易对数据
    isFuturesUsdtOpen: undefined as StateProps["isFuturesUsdtOpen"], //判断U本位合约是否开通
    isFuturesCoinOpen: undefined as StateProps["isFuturesCoinOpen"], //判断币本位合约是否开通
    isEquityTransferOpen:undefined as StateProps["isEquityTransferOpen"], // 判断股票账户是否在白名单
    isEquityWhiteOpen:undefined as StateProps["isEquityWhiteOpen"], // 判断股票账户是否可申请白名单
    isEquityWithdraw:undefined as StateProps["isEquityWithdraw"], // 判断股票账户划转开关
    futuresUsdtTransferList: undefined as StateProps["futuresUsdtTransferList"], //U本位合约可划转币种列表
    futuresCoinTransferList: undefined as StateProps["futuresCoinTransferList"], //币本位合约可划转币种列表
    equityCoinTransferList: undefined as StateProps["equityCoinTransferList"], //股票可划转列表
    equityExChangeList: undefined as StateProps["equityExChangeList"], //股票兑换列表
    futuresUsdtConfigAry: undefined as StateProps["futuresUsdtConfigAry"], //U本位合约所有市场配置信息，数组
    feeRate: {} as StateProps["feeRate"], //缓存所有市场的费率
    etfList: undefined as StateProps["etfList"], //etf交易对列表，数组
    etfListBase: undefined as StateProps["etfListBase"], //etf单个配置，数组
    equityLimit: undefined as StateProps["equityLimit"],
    isEquityHK: undefined as StateProps["isEquityHK"], // 是否是港股
    brokerLink: undefined as StateProps["brokerLink"], // 券商下载链接

    get config(): WithUndefined<ObjT<SymbolProps>> {
      if (!this.symbols) return;
      const doc: ObjT<SymbolProps> = {};
      this.symbols.map((obj: any) => (doc[obj.symbol] = obj));
      return doc;
    }, //所有市场配置信息，对象
    get currentConfig(): Partial<SymbolProps> {
      if (!this.name || !this.config) return {};
      return this.config[this.name] || {};
    }, //当前市场配置信息
    get leverConfigObj(): WithUndefined<ObjT<LeverSymbolProps>> {
      if (!this.leverConfigAry) return;
      const doc: ObjT<LeverSymbolProps> = {};
      this.leverConfigAry.map((obj: any) => (doc[obj.symbol] = obj));
      return doc;
    }, //杠杆所有市场配置信息，对象
    get currentLeverConfig(): Partial<LeverSymbolProps> {
      if (!this.leverConfigObj || !this.leverConfigObj[this.name]) return {};
      return this.leverConfigObj[this.name];
    }, //当前杠杆市场配置信息
    get isLever(): boolean {
      return this.type === TypeEnum.lever;
    }, //是否是杠杆市场
    get isEtf(): boolean {
      if (!this.name || !this.config) return false;
      const cfg = this.config[this.name];
      if (!cfg) return false;
      return this.isEtfSymbolFnNew(cfg.symbol);
    }, //当前市场是否是 etf 市场
    get isNft(): boolean {
      return this.currentConfig.type === "nft";
    }, //当前市场是否是 nft 市场
    get currentNftCoin(): string {
      if (!this.isNft || !this.name) return "";
      if (!StoreCurrency.currencyObj) return "";
      const [baseCurrency, quoteCurrency] = this.name.split("_");
      if (StoreCurrency.currencyObj[baseCurrency] && StoreCurrency.currencyObj[baseCurrency].type === "NFT") return baseCurrency;
      if (StoreCurrency.currencyObj[quoteCurrency] && StoreCurrency.currencyObj[quoteCurrency].type === "NFT") return quoteCurrency;
      return "";
    }, //当前 nft 币种

    get etfConfigObj(): WithUndefined<ObjT<EtfProps>> {
      if (!this.etfList) return;
      const doc: ObjT<EtfProps> = {};
      this.etfList.map((item: any) => (doc[item.symbol] = item));
      return doc;
    }, //ETF所有市场配置信息，对象

    updateState(payload: Partial<StateProps>) {
      for (const va in payload) {
        this[va] = payload[va];
      }
    },
    updateStateOnce(payload: Partial<StateProps>) {
      for (const va in payload) {
        if (!this[va]) this[va] = payload[va];
      }
    },
    formatName(symbol: string): string {
      // !symbol && (symbol = this.name);
      // return symbol.split("_").join("/").toUpperCase();

      return symbol
        .split("_")
        .map((coin) => StoreCurrency.getCurrencyDisplayName(coin))
        .join("/");
    }, //对市场名称进行格式化，btc_usdt -> BTC/USDT
    async formatNameSafe(symbol: string): Promise<string> {
      const coins = symbol.split("_");
      const displayNames = await Promise.all(coins.map((coin) => StoreCurrency.getCurrencyDisplayNameSafe(coin)));
      return displayNames.join("/");
    },
    async formatCodeSafe(symbol: string): Promise<string> {
      const coins = symbol.split("_")[0];
      return await StoreCurrency.getCurrencyCodeSafe(coins);
    },
    //
    getMarketConfig() {
      if (loading_getMarketConfig) return;
      loading_getMarketConfig = true;

      const { version } = Storage.get("symbols") || {};
      let { symbols } = Storage.get("symbols") || {};
      // this.symbols = symbols;

      get_symbol({
        params: {
          version,
        },
      })
        .then((data) => {
          if (data.symbols && data.version !== version) {
            console.log("【getSymbol update】", data);
            symbols = data.symbols;
            // this.symbols = data.symbols;
            Storage.set("symbols", data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.symbols = symbols;
          loading_getMarketConfig = false;
        });
    }, //获取所有市场
    loopGetMarketConfig() {
      clearTimeout(TimeoutFun_loopGetMarketConfig);
      try {
        CancelFun_loopGetMarketConfig && CancelFun_loopGetMarketConfig();
      } catch (e) {
        CancelFun_loopGetMarketConfig = null;
      }

      const { version } = Storage.get("symbols") || {};
      let { symbols } = Storage.get("symbols") || {};

      get_symbol({
        params: {
          version,
        },
        cancelFun: (c) => (CancelFun_loopGetMarketConfig = c),
      })
        .then((data) => {
          if (data.symbols && data.version !== version) {
            console.log("【getSymbol update】", data);
            symbols = data.symbols;
            // this.symbols = data.symbols;
            Storage.set("symbols", data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.symbols = symbols;
          CancelFun_loopGetMarketConfig = null;
          clearTimeout(TimeoutFun_loopGetMarketConfig);
          TimeoutFun_loopGetMarketConfig = setTimeout(() => {
            this.loopGetMarketConfig();
          }, 3e3);
        });
    }, //轮询获取所有市场
    getLeverMarketConfig(finallyFun?: () => void) {
      get_leverSymbol()
        .then((data: StateProps["leverConfigAry"]) => {
          this.leverConfigAry = data;
        })
        .finally(finallyFun);
    }, //获取杠杆所有市场
    getFapiSymbolList() {
      // [ju一期不上] 
      // get_fapiSymbolList().then((data) => {
      //   this.futuresUsdtConfigAry = data;
      // });
    }, //获取U本位合约市场列表
    getEtfByTradeMarket() {
      // post_getEtfByTradeMarket({ data: { pairs: [] } }).then((data) => {
      //   const etfConfig = {};
      //   data.map(({ marketName, data }) => {
      //     etfConfig[marketName] = { data };
      //   });
      //   this.etfConfig = etfConfig;
      // });
    }, //获取现货市场对应的etf所有市场
    getMarketTips() {
      get_marketTips().then((data) => {
        const obj = {};
        data.map((doc) => {
          obj[doc.marketName] = doc;
        });
        this.tips = obj;
      });
    }, //获取市场风险提示信息
    getPlateList() {
      get_plate().then((data) => {
        this.plateList = data;
      });
    }, //获取板块列表
    isEtfSymbolFn(symbolCfg: SymbolProps) {
      if (symbolCfg.plates && symbolCfg.plates.includes(145)) return true;
      return false;
    }, //判断是否是etf市场
    isEtfSymbolFnNew(symbol: string) {
      const marketEtfConfig: string[] = [];
      this.etfList?.map((item) => {
        marketEtfConfig.push(item.symbol);
      });
      return marketEtfConfig.includes(symbol);
    }, //判断是否是etf市场(新)
    isMarketOpenFn(symbolCfg: ObjAny | SymbolProps, { server, local }): boolean {
      const { state, nextState, nextStateTime } = symbolCfg;
      if (state === "ONLINE") return true;
      if (state === "OFFLINE" && nextState === "ONLINE") {
        if (!nextStateTime || !server) return true;
        return server + (Date.now() - local) - nextStateTime > 0;
      }
      return true;
    }, //判断当前市场，是否已开盘的函数
    getFapiAccountOpen(finallyFun?: () => void) {
      if (this.isFuturesUsdtOpen) return finallyFun && finallyFun();
      get_fapiAccountOpen()
        .then((result) => {
          this.isFuturesUsdtOpen = result;
        })
        .finally(finallyFun);
    }, //判断U本位合约是否开通
    getDapiAccountOpen(finallyFun?: () => void) {
      if (this.isFuturesCoinOpen) return finallyFun && finallyFun();
      get_dapiAccountOpen()
        .then((result) => {
          this.isFuturesCoinOpen = result;
        })
        .finally(finallyFun);
    }, //判断币本位合约是否开通
    getFapiCoins(finallyFun?: () => void) {
      get_fapiCoins()
        .then((result) => {
          this.futuresUsdtTransferList = result;
        })
        .finally(finallyFun);
    }, //U本位合约可划转币种列表
    getDapiCoins(finallyFun?: () => void) {
      get_dapiCoins()
        .then((result) => {
          this.futuresCoinTransferList = result;
        })
        .finally(finallyFun);
    }, //币本位合约可划转币种列表
    getExChangeList(finallyFun?: () => void) {
      get_exchange_list().then((data) => {
        this.equityExChangeList = data;
      }).finally(finallyFun);
    }, // 股票兑换列表
    getEquityCoins(finallyFun?: () => void) {
      get_equityCoins()
        .then((result) => {
          this.equityCoinTransferList = result;
        })
        .finally(finallyFun);
    }, // 股票可划转列表
    getEquityLimit(finallyFun?: () => void) {
      get_equityTransLimit()
        .then((result) => {
          // result = {
          //   whiteEnabled: true, // 是否开启白名单
          //   isWhite: 0, // 开启白名单&&1才可以划转，0无效
          //   minAmount: 1, // 现货 => 股票最小金额限制
          //   transferEnabled: false // 是否开启划转
          // }
          this.isEquityTransferOpen = result.transferEnabled && (!result.whiteEnabled || (result.whiteEnabled && result.isWhite === 1));
          this.isEquityWhiteOpen = result.whiteEnabled && result.isWhite === 0;
          this.isEquityWithdraw = result.transferOutEnabled; // 新增划转开关
          this.equityLimit= result;
        })
        .finally(finallyFun);
    }, // 股票白名单限制
    getSymbolFeeRate(name?) {
      const symbol = name || this.name;
      if (this.feeRate[symbol]) return;
      console.log("symbol====", symbol, this.name);
      get_symbolFeeRate({
        params: { symbol },
      }).then((result) => {
        const feeRate = { ...this.feeRate };
        feeRate[symbol] = result;
        this.feeRate = feeRate;
      });
    }, //获取交易对市场费率
    getBrokerLink() {
      get_broker_link().then((data) => {
        this.brokerLink = data.securitiesDownload;
      })
    },// 获取券商下载链接
    // getEtfList(finallyFun?: () => void) {
    //   get_etf_list()
    //     .then((res) => {
    //       this.etfList = res;
    //     })
    //     .finally(finallyFun);
    // }, // 获取etf交易对列表
    // getEtfListBase(finallyFun?: () => void) {
    //   get_etf_list({ params: { baseCurrency: this.currentConfig.baseCurrency } })
    //     .then((res) => {
    //       this.etfListBase = res;
    //     })
    //     .finally(finallyFun);
    // }, // 获取单个etf配置
    getEtfWorth(finallyFun?: () => void) {
      // get_net_worth(this.currentConfig.id)
      //   .then((res) => {
      //     this.netWorth = res?.n;
      //   })
      //   .finally(finallyFun);
    }, // 获取
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default market;
